import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Errors, Modal, PlaceholderLoader } from '../../components/index.js';
import { getFile } from '@debbie/cortex/dist/files.js';
import ObjectComp from '../ObjectComp.js';
const LetterPreview = (props) => {
    const lang = useSelector((s) => s.lang);
    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (props.downloadUrl) {
            getFile(props.downloadUrl)
                .then(setFile)
                .catch((err) => {
                console.error(err);
                setError(lang.interactions.downloadFailed);
            });
        }
    }, [props.downloadUrl]);
    return (React.createElement(Modal, { onToggle: props.onToggle, header: lang.interactions.preview },
        file == null && error == null ? React.createElement(PlaceholderLoader, null) : null,
        error ? React.createElement(Errors, { errors: [error] }) : null,
        file ? React.createElement(ObjectComp, { url: file, type: "application/pdf" }) : null));
};
export default LetterPreview;
//# sourceMappingURL=LetterPreview.js.map